import { render } from "./toReply.vue?vue&type=template&id=db77b6fa&scoped=true"
import script from "./toReply.vue?vue&type=script&lang=js"
export * from "./toReply.vue?vue&type=script&lang=js"

import "./toReply.vue?vue&type=style&index=0&id=db77b6fa&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db77b6fa"]])

export default __exports__